import React, {useEffect, useState, useRef } from 'react';
import {callLogout} from '@api/CommonApi';
import {HttpStatusCode} from 'axios';

import IconAlarm from '@icon/IconAlarm';
import IconLogout from '@icon/IconLogout';
import IconAdmin from '@icon/IconAdmin';
import Logo from '../assets/images/logo.png';
import {useRecoilValue} from 'recoil';
import {sessionInfoAtom} from '@atom/sessionInfoAtom';
import {
    alarmItem
    ,alarmSearchCondition
} from "@interface/master/Alarm";
import {
    callUpdateAlarm, callUpdateAlarmAll,
    getSensorAlarmList
} from "@api/AlarmApi";
import IconHumidity from "@icon/IconHumidity";
import IconBattery from "@icon/IconBattery";
import IconGps from "@icon/IconGps";
import IconProtractor from "@icon/IconProtractor";
import IconShock from "@icon/IconShock";
import IconSound from "@icon/IconSound";
import IconSet from "@icon/IconSet";
import {getUserPassword} from '@api/UserManagementApi';
import {getFileDownloadUrl, getFileList} from '@api/FileApi';
import {FileInfo} from '@interface/common/File';


function Menu() {
    return (
        <>
            <p key={'menu1'} className='menu-main-link'><a href="/">상황판</a></p>
            <p key={'menu2_1'} className='menu-main-link'><a href="/dashboard-detail">대시보드상세</a></p>
            <p key={'menu2_2'} className='menu-main-link'><a href="/sensor-data">센서데이터</a></p>
            <p key={'menu2_3'} className='menu-main-link'><a href="/sensor-statistics">통계</a></p>
        </>
    );
}

const Header = () => {
    const sessionInfo = useRecoilValue(sessionInfoAtom);
    const [isMenuHovered, setIsMenuHovered] = useState(false);
    //
    const handleMouseEnter = () => { setIsMenuHovered(true); };
    const handleMouseLeave = () => { setIsMenuHovered(false); };

    const [sensorAlrmData, setSensorAlrmData] = useState<alarmItem[]>([]);
    const [alarmSearchCondition, setAlarmSearchCondition] = useState<alarmSearchCondition>({allFlag:false});
    const iconMap: { [key: string]: JSX.Element }= {
        'IconGps': <IconGps />,
        'IconHumidity': <IconHumidity />,
        'IconProtractor': <IconProtractor />,
        'IconShock': <IconShock />,
        'IconSound': <IconSound />,
        'IconBattery': <IconBattery />,
    };

    const logout = async () => {
       const data = await callLogout();
       if(data.code === HttpStatusCode.Ok)
           location.href = location.pathname;
    };

    const [isOn, setIsOn] = useState(false);

    const handleToggle = () => {
        if(!isOn)
        {
            if (isFileOpen) setIsFileOpen(false);
            getSensorAlarmList(false).then((res) => {
                if (res.code === HttpStatusCode.Ok && res.item) {
                    setSensorAlrmData(res.item);
                    setIsOn(!isOn);
                }
            });
        }
        else
        {
            setIsOn(!isOn);
        }
    };

    // 관리자 사이트 편의 로그인: 관리자 사이트가 "/{userId}987654321{비밀번호해시}" 경로를 해석해 자동 로그인한다 (운영 jar 동작)
    const moveAdm = () => {
        getUserPassword().then((res) => {
            if (res.code === HttpStatusCode.Ok && res.item) {
                window.open("https://safeiot-admin.eseoul.go.kr/" + sessionInfo.userId + "987654321" + res.item.passwd, "_blank", "noopener,noreferrer");
            }
        });
    };

    // 자료실 파일 다운로드 팝업 (헤더 "파일" 버튼)
    const [isFileOpen, setIsFileOpen] = useState(false);
    const [fileList, setFileList] = useState<FileInfo[]>([]);

    const handleFileToggle = () => {
        if (isOn) setIsOn(false);
        setIsFileOpen(prev => !prev);
    };

    const downloadFile = (fileName: string) => {
        window.location.href = getFileDownloadUrl(fileName);
    };

    // 표시명: "[분류] 파일명.pdf" → "파일명"
    const displayFileName = (fileName: string) => fileName.replace(/^.*\] /, '').replace('.pdf', '');

    const dataSearch = async (allFlag:boolean) => {
        getSensorAlarmList(allFlag).then((res) => {
            if (res.code === HttpStatusCode.Ok && res.item) {
                setSensorAlrmData(res.item);
            }
        });
    };

    const updateChk = (snsrAlrmSeq: number) => {
        setSensorAlrmData(prevItems =>
            prevItems.map(item =>
                item.snsrAlrmSeq === snsrAlrmSeq ? { ...item, readCls: '', chkFlag : true } : item
            )
        );
        const saveSensorAlrmData = sensorAlrmData.find(item => item.snsrAlrmSeq === snsrAlrmSeq);
        if (saveSensorAlrmData) {
            callUpdateAlarm(saveSensorAlrmData).then(res => {
            });
        }
    };

    const readAll = () => {
        setSensorAlrmData(prevItems =>
            prevItems.map(item => ({ ...item, chkFlag: true, readCls: '' }))
        );
        callUpdateAlarmAll().then();
    };


    useEffect(() => {
        dataSearch(false);
        getFileList().then((res) => {
            setFileList(res && Array.isArray(res.item) ? res.item : []);
        }).catch(() => {
            setFileList([]);
        });
    }, []);

    return (
        <div className='header_wrap' >
            {/*<div*/}
            {/*    className={!isMenuHovered ? 'menu-dim' : 'menu-dim on'}*/}
            {/*    onMouseEnter={handleMouseEnter}*/}
            {/*    onMouseLeave={handleMouseLeave}*/}
            {/*></div>*/}

            <div className='inner'>
                <a className='logo' href="/">
                    <img src={Logo} alt='서울특별시' />
                </a>

                <div
                    className="menu"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <Menu />
                </div>

                <div className='login'>
                    <div className='user'>
                        <div className='thumb'>
                            <IconAdmin/>
                        </div>
                        <div className='name'>{(sessionInfo && sessionInfo.userName) ?? ''}님</div>
                    </div>

                    {sessionInfo.admFlag && (
                    <div className='admin' onClick={moveAdm}>
                        <IconSet />
                        [관리자 페이지]
                    </div>)}

                    <div className='alarm' onClick={handleToggle}>
                        <IconAlarm />
                        <span className='num'>{sensorAlrmData.filter(item => !item.chkFlag).length}</span>
                    </div>

                    <div className='download' onClick={handleFileToggle}>
                        <span>파일</span>
                    </div>

                    <div className={`alarm-pop ${isOn ? "on" : ""}`} >
                        <p className='tit'>
                            알림
                            <button className='btn btn-read' type='button' onClick={readAll}>전체 읽음</button>
                        </p>
                        {isOn && (
                                <ul className='list' >
                                    {sensorAlrmData.map((item) => {
                                        return (
                                            <li key={item.snsrAlrmSeq}>
                                                <a className={item.readCls} onClick={() => {
                                                    updateChk(item.snsrAlrmSeq);
                                                }}>
                                                    <span className={item.iconCls}>
                                                        {iconMap[item.iconImg]}
                                                    </span>
                                                    <div>
                                                        <p>{item.alarmText1}</p>
                                                        <p>{item.alarmText2}</p>
                                                    </div>
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}


                        <button className='btn btn-more' onClick={() => {
                            dataSearch(true);
                        }}>이전 알람 보기</button>
                    </div>

                    <div className={`download-pop ${isFileOpen ? "on" : ""}`}>
                        <p className='tit'>파일 다운로드</p>
                        <ul className='list'>
                            {fileList.length > 0 ? fileList.map((file, idx) => (
                                <li key={`${file.fileName}-${idx}`}>
                                    <button type='button' onClick={() => downloadFile(file.fileName)}>
                                        {displayFileName(file.fileName)}
                                    </button>
                                </li>
                            )) : (
                                <li key='no-files'>다운로드 가능한 파일이 없습니다.</li>
                            )}
                        </ul>
                    </div>

                    <div className='logout' onClick={logout}>
                        <IconLogout />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;